import _ from "lodash";
import React from "react";
import classes from "./AttachmentLoader.scss";
import AttachmentStatus from "./AttachmentStatus";
import { getThumbUrl } from "Utils";

import I18nHOC from "UIComponents/I18nHOC";

import { IconButton } from "@toddle-edu/ds-web";

import { CloseOutlined } from "@toddle-edu/ds-icons";

class AttachmentLoader extends React.PureComponent {
  render() {
    const { t } = this.props;
    const item = _.get(this.props, "item", {});
    const attachment = _.get(item, "attachment", {});
    const status = _.get(item, "status");

    const { thumbUrl, isIcon, color } = getThumbUrl({
      attachment: attachment,
      width: 80,
      height: 80,
    });

    const name = _.get(attachment, "name", "");
    const url = _.get(attachment, "url", "");

    const totalProgress = url && url.startsWith("blob:") ? 100 : 50;

    const size =
      attachment?.metadata && attachment.metadata.size
        ? attachment.metadata.size / 1000
        : 0;

    let progressValue = parseInt(_.get(item, `progress`, "100"));
    const currentProgress =
      totalProgress === 100 ? progressValue : progressValue - 50;
    progressValue =
      totalProgress === 100 ? currentProgress : currentProgress * 2;
    const calcUploadedSize = (size * currentProgress) / totalProgress;
    const uploadedSize = calcUploadedSize > 0 ? calcUploadedSize : 0;

    return (
      <div className={classes.container}>
        <div
          className={classes.imageContainer}
          style={{
            backgroundImage: `url(${thumbUrl})`,
            backgroundSize: isIcon ? "35%" : "cover",
            backgroundColor: color,
          }}
        />
        {status == "UPLOAD" && (
          <AttachmentStatus
            progressValue={progressValue}
            item={item}
            name={name}
            title={"calculating"}
            uploadedSize={uploadedSize}
            size={size}
          />
        )}
        {status == "PROCESSING" && (
          <AttachmentStatus
            progressValue={progressValue}
            item={item}
            name={name}
            title={"processing_file"}
            uploadedSize={uploadedSize}
            size={size}
          />
        )}
        {status == "COPYING" && (
          <AttachmentStatus
            progressValue={progressValue}
            item={item}
            name={t("equationEditor:mathematics_formula")}
            title={"copying"}
            uploadedSize={uploadedSize}
            size={size}
          />
        )}
        {status == "INSERTING" && (
          <AttachmentStatus
            progressValue={progressValue}
            item={item}
            name={t("equationEditor:mathematics_formula")}
            title={"inserting"}
            uploadedSize={uploadedSize}
            size={size}
          />
        )}
        {status == "DOWNLOAD" && (
          <div className={classes.processing}>
            <div className={classes.fileName}>
              {t("common:processing_file")}
            </div>
            <div className={classes.iconContainer}>
              {item.cancelToken && (
                <IconButton
                  onClick={item.cancelToken}
                  icon={<CloseOutlined />}
                  variant={"plain"}
                  size={"xx-small"}
                />
              )}
            </div>
          </div>
        )}
        {status == "SAVE" && (
          <div className={classes.saveContainer}>
            <div className={classes.statusText}>{t("common:saving")}</div>
            <div className={classes.fileName} dir="auto">
              {name}
            </div>
          </div>
        )}
        {_.includes(status, "COPYINGIMAGE") && (
          <AttachmentStatus
            progressValue={progressValue}
            item={item}
            name={status.split("-")[1]}
            title={"pasting_image"}
            uploadedSize={uploadedSize}
            size={size}
          />
        )}
      </div>
    );
  }
}

// Set default props
AttachmentLoader.defaultProps = {
  title: "calculating",
};

export default I18nHOC({ resource: ["common", "moment", "equationEditor"] })(
  AttachmentLoader
);
